// @flow
export const article = {
  title: 'OmahaPro',
  description: 'Articles to help you become better at Pot Limit Omaha. Plo strategy.',
};

export const article0 = {
  title: 'OmahaPro',
  description: 'Types of starting hand\'s in pot limit omaha. Single suited or double suited?',
};

export const article1 = {
  title: 'OmahaPro',
  description: 'Explanation of good suited or bad suited hand\'s in pot limit omaha.',
};

export const training = {
  title: 'PLO GTO Training',
  description: 'PLO GTO Training for preflop for  low mid and high stakes.',
};

export const preflop = {
  title: 'Preflop',
  description: 'PLO GTO Preflop that helps you to be a better player for low mid and high stakes presented in a convenient form.',
};

export const home = {
  title: 'OmahaPro',
  description: 'OmahaPro is a Pot Limit Omaha training site. Here you will find information on preflop and you'
    + ' can consolidate your knowledge in the simulator. Preflop will help you understand PLO ranges better, and Training will help you'
    + ' reinforce that knowledge. Learn PLO GTO strategy for cash games and MTT.',
};

export const faq = {
  title: 'FAQ OmahaPro',
  description: 'FAQ for Pot Limit Omaha Preflop software. Single suited and Double suited hands. Situations against 3bet.',
};

export const textGuide = {
  title: 'guide OmahaPro',
  description: 'FAQ for Pot Limit Omaha Preflop software.',
};
